<div class="custom-badge">
	<mat-icon [svgIcon]="svgIcon" class="icon" [ngStyle]="{ 'font-size': size}">
		{{icon}}
	</mat-icon>
	<span class="count" [ngStyle]="{ 'color': color}">
		{{count}}
	</span>
</div>
